import T from './_tracker';

export var Tracker = T;
export default T;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@spt-tracking/pulse-sdk/dist/ejs/index.js
// module id = 1113
// module chunks = 0